export default "__VITE_ASSET__5e123ec4__"